<template>
  <div class="content-box">
    <div class="tree-list heitani">
      <div class="lefthead">
        <span v-if="articleType == 1">系统介绍</span
        ><span v-else>通知公告</span>
      </div>
      <div>
        <div
          :class="
            detail.articleId == item.articleId ? 'leftpro activepro' : 'leftpro'
          "
          :key="item.articleId"
          v-for="item in list"
          @click="getDetail(item.articleId)"
        >
          <i class="el-icon-right" v-show="detail.articleId == item.articleId"></i>
          <i class="el-icon-document" v-show="detail.articleId !== item.articleId"></i>
          {{ item.articleTitle }}
        </div>
        <!-- <div class="leftpro">逻辑检索说明</div>
        <div class="leftpro">一般检索使用说明</div> -->
      </div>
    </div>
    <div class="select-content flex-grow">
      <!-- <h2>{{ detail.articleTitle }}</h2> -->
      <p v-html="detail.articleContent"></p>
    </div>
  </div>
</template>

<script>
import {
  getArticleList,
  getArticleDetail
} from "@/api/api"
export default {
  name: "Introduce",
  // props: {
  //   isLogin: false,
  //   isVip: false,//是否vip
  // },
  props: ['articleType'],
  data () {
    return {
      list: [],
      detail: []

    }
  },
  mounted () {
    this.getArticleList()

  },
  methods: {
    getArticleList () {
      this.list = []
      this.detail = []
      getArticleList({ articleType: this.articleType }).then((data) => {
        if (data.rows && data.rows.length == 0) {
          this.emptyText = "暫無數據"
          return
        }
        this.list = data.rows
        this.getDetail(this.list[0].articleId)
        // console.log(this.list, 'this.list')

      })
    },
    getDetail (id) {
      getArticleDetail(id).then((data) => {
        this.detail = data.data
        // console.log(data, 'dt')
      })
    }
  },
  watch: {
    articleType (nv, ov) {

      this.getArticleList()
    }
  }

}
</script>

<style lang="less" scoped>
.content-box {
  width: 100%;
  display: -webkit-box;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  overflow: auto;
  padding: 16px 10px;
  background: rgb(244, 240, 232);
  .lefthead {
    height: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #573E0D;
    letter-spacing: 0;
    line-height: 64px;
    //border-bottom: 1px solid #eeeeee;
    span {
      display: inline-block;
      //border-bottom: 2px solid #2c7e8d;
    }
  }
}
.content-box .tree-list {
  margin-right: 16px;
  padding: 24px;
  width: 300px;
  position: relative;
  background: #FEFBF4;
  border-radius: 8px;
  overflow: hidden;
  height: 86vh;
  .leftpro {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    text-align: left;
    line-height: 2.5;
    font-weight: 400;
    padding: 0 10px;
    cursor: pointer;
    margin: 4px 0;
  }
  .leftpro:hover {
    background: #EDE4D3;
    border-radius: 4px;
    color: #573E0D;
  }
  .activepro {
    background: #EDE4D3;
    border-radius: 4px;
    color: #573E0D;
  }
}

.content-box .select-content {
  -webkit-box-flex: 3;
  -ms-flex: 3;
  flex: 3;
  padding:2rem 3rem;
  // line-height: 2;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  height: 86vh;
  background: #fff;
  overflow: auto;
  // padding: 20px;
  h2 {
    font-family: PingFang-SC-Bold;
    font-size: 32px;
    color: #2c7e8d;
    letter-spacing: 0;
    text-align: center;
    line-height: 2.5;
    font-weight: 700;
  }
  p {
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    line-height: 2.5;
    font-weight: 500;
  }
}
.ql-font-FangZheng-FanTi {
  font-family: "FangZheng-FanTi";
}
.FangZheng-FanTi-Kaiti {
  font-family: "FangZheng-FanTi-Kaiti";
}
.ql-font-SimSun {
  font-family: "SimSun";
}
.ql-font-SimHei {
  font-family: "SimHei";
}
.ql-font-Microsoft-YaHei {
  font-family: "Microsoft YaHei";
}
.ql-font-KaiTi {
  font-family: "KaiTi";
}
.ql-font-FangSong {
  font-family: "FangSong";
}
.ql-font-Arial {
  font-family: "Arial";
}
.ql-font-Times-New-Roman {
  font-family: "Times New Roman";
}
.ql-font-sans-serif {
  font-family: "sans-serif";
}
.ql-lineheight {
  width: 70px;
}
.ql-lineheight-1 {
  line-height: 1;
}
.ql-lineheight-1-5 {
  line-height: 1.5;
}
.ql-lineheight-1-75 {
  line-height: 1.75;
}
.ql-lineheight-2 {
  line-height: 2;
}
.ql-lineheight-3 {
  line-height: 3;
}
.ql-lineheight-4 {
  line-height: 4;
}
.ql-lineheight-5 {
  line-height: 5;
}
</style>



// WEBPACK FOOTER //
// src/view/introduce/index.vue